jQuery(function () {
  // AOS

  AOS.init();
  // var image = document.getElementsByClassName('parallax-bg');

  // new simpleParallax(image, {
  //     scale: 1.25
  // });
  var heroSlider = new Swiper(".slider", {
    // loop: true,
    // effect: 'fade',
    // fadeEffect: {
    //     crossFade: true
    // },
    breakpoints: {
      // when window width is >= 320px
      950: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
    slidesPerView: 2,
    spaceBetween: 15,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
      clickable: true,
    },
    // autoplay: {
    //     delay: 5000,
    //     disableOnInteraction: false,
    // },
  });

  var testimonialsSlider = new Swiper(".testimonials-slider", {
    loop: true,
    // effect: 'fade',
    // fadeEffect: {
    //     crossFade: true
    // },
    slidesPerView: "auto",
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
      clickable: true,
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  });

  var gallerySlider = new Swiper(".gallery-slider", {
    loop: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
      clickable: true,
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  });

  var iconsSlider = new Swiper(".icons-slider", {
    loop: true,
    slidesPerView: "auto",
    spaceBetween: 70,
    centeredSlides: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      dynamicBullets: true,
      clickable: true,
    },

    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
  });
  iconsSlider.on("slideChangeTransitionEnd", function () {
    var currentActiveSlide = $(
      ".icons-slider .swiper-slide-active .slide-img",
    ).attr("src");
    $(".slide-bg img").attr("src", currentActiveSlide);
  });

  var setSlideBg = $(".icons-slider .swiper-slide-active .slide-img").attr(
    "src",
  );
  $(".slide-bg img").attr("src", setSlideBg);

  var benefitsSlider = new Swiper(".benefits-slider", {
    loop: true,
    slidesPerView: "auto",
    centeredSlides: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    // autoplay: {
    //     delay: 3000,
    //     disableOnInteraction: false,
    // },
    on: {
      init: function () {
        let currentActiveSlide = document.querySelector(
          ".benefits-slider .swiper-slide-active",
        ).dataset.slideHeader;
        const sliderHeadingEl = document.querySelector(
          ".benefits-slider-footer h4",
        );
        sliderHeadingEl.innerHTML = currentActiveSlide;
      },
    },
  });
  benefitsSlider.on("slideChangeTransitionEnd", function () {
    let currentActiveSlide = document.querySelector(
      ".benefits-slider .swiper-slide-active",
    ).dataset.slideHeader;
    const sliderHeadingEl = document.querySelector(
      ".benefits-slider-footer h4",
    );
    sliderHeadingEl.style.opacity = 0;
    setTimeout(() => {
      sliderHeadingEl.innerHTML = currentActiveSlide;
      sliderHeadingEl.style.opacity = 1;
    }, 100);
  });

  // Introduction GSAP

  if ($("main").hasClass("is-home")) {
    // modal window

    // setTimeout(() => {
    //     $(window).scroll(function() {
    //         var windscroll = $(window).scrollTop();
    //         if (windscroll >= 1000) {
    //             $('.newsletter-modal').toggleClass('hidden')
    //             $(window).unbind('scroll');
    //         }
    //     })
    // }, 4000);

    var heroSlider = new Swiper(".page--header__slider", {
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: ".button-next",
        prevEl: ".button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: true,
        clickable: true,
      },
      autoplay: {
        delay: 7500,
        disableOnInteraction: false,
      },
    });

    const heroText = document.querySelectorAll(
      ".swiper-slide-active:nth-of-type(2) h3",
    );
    const fadeGroup = document.querySelectorAll(
      ".hero-slide__background, .fade-group",
    );
    const fadeGroup2 = document.querySelectorAll(".hero-slide h3 .back");

    const heroCtaBlocks = new TimelineMax();

    heroCtaBlocks
      .to(heroText, 0.5, {
        y: 0,
        autoAlpha: 1,
        ease: Power2.easeOut,
        delay: 0.75,
        onComplete: function () {
          $(".body-bg").toggleClass("dark");
        },
      })
      .to(fadeGroup, 0.5, { y: 0, autoAlpha: 1, ease: Power2.easeInOut }, "-=1")
      .to(fadeGroup2, 0.5, { autoAlpha: 0, ease: Power2.easeInOut });
  } else if ($("main").hasClass("is-product")) {
    const fadeGroup = document.querySelectorAll(".fade-group");
    const fadeGroup2 = document.querySelectorAll(".page--header");

    const heroCtaBlocks = new TimelineMax();

    heroCtaBlocks.to(fadeGroup, 1, {
      y: 0,
      autoAlpha: 1,
      ease: Power2.easeOut,
      delay: 0.75,
    });
  } else if ($("main").hasClass("is-page")) {
    const heroText = document.querySelectorAll(
      ".landing__header h2, .page--header__copy h2",
    );
    const fadeGroup = document.querySelectorAll(".fade-group");
    const fadeGroup2 = document.querySelectorAll(
      ".page--header__copy h2 .back, .page--header__copy h1 .back",
    );

    const heroCtaBlocks = new TimelineMax();

    heroCtaBlocks
      .to(heroText, 0.5, {
        y: 0,
        autoAlpha: 1,
        ease: Power2.easeOut,
        delay: 0.5,
        onComplete: function () {
          $(".body-bg").toggleClass("dark");
        },
      })
      .to(fadeGroup, 0.5, { y: 0, autoAlpha: 1, ease: Power2.easeInOut }, "-=1")
      .to(fadeGroup2, 0.5, { autoAlpha: 0, ease: Power2.easeInOut });
  } else if ($("main").hasClass("is-product-list")) {
    const fadeGroup = document.querySelectorAll(".fade-group");
    const fadeGroup2 = document.querySelectorAll(".product__desc .back");

    const heroCtaBlocks = new TimelineMax();

    heroCtaBlocks
      .to(fadeGroup, 1.25, {
        y: 0,
        autoAlpha: 1,
        ease: Power2.easeOut,
        delay: 0.75,
      })
      .to(fadeGroup2, 0.75, { autoAlpha: 0, ease: Power2.easeInOut });
  }

  $("#modal-close, #modal-bg-close, #references").on("click", function () {
    $(".references-modal").toggleClass("hidden");
    console.log("hello");
  });

  // Navigation

  $("#menu-btn").on("click", function () {
    $("body").toggleClass("nav-open");
  });

  $(window).scroll(function () {
    var windscroll = $(window).scrollTop();
    if (windscroll >= 1) {
      $(".main-nav").addClass("has-border");
      $(".notification").addClass("has-border");
    } else {
      $(".main-nav").removeClass("has-border");
      $(".notification").removeClass("has-border");
    }
  });

  var windscrolla = $(window).scrollTop();

  // if (windscrolla >= !100) {
  //     setTimeout(function(){
  //         $('.notification').addClass('is-visible');
  //     }, 1200)
  // }

  if ($("#notification").length) {
    $(window).scroll(function () {
      var windscroll = $(window).scrollTop();
      if (windscroll >= 700) {
        $("body").addClass("notify-hide");
      } else {
        $("body").removeClass("notify-hide");
      }
    });
  }

  document.addEventListener("touchstart", function () {}, true);

  // Resize WP Block spacer

  function resizeSpacer() {
    let allSpacers = document.querySelectorAll(".wp-block-spacer");
    // Breakpoints
    let tabletBp = 992;
    let tabletReduction = 0.75;
    let mobileBp = 678;
    let mobileReduction = 0.5;
    for (let i = 0; i < allSpacers.length; i++) {
      let el = allSpacers[i];
      let style = el.getAttribute("style");
      let number = parseInt(style.slice(7, -2));

      if (window.innerWidth <= 992 && window.innerWidth >= 678) {
        number = number * tabletReduction;
        el.style.height = number + "px";
      } else if (window.innerWidth <= 678) {
        number = number * mobileReduction;
        el.style.height = number + "px";
      }
    }
  }
  resizeSpacer();

  // Find links that are #anchors and scroll to them

  $('a[href^="#"]')
    .not(".lp-pom-form .lp-pom-button")
    .unbind("click.smoothScroll")
    .bind("click.smoothScroll", function (event) {
      event.preventDefault();
      const href = $(this).attr("href").split("#");
      $("html, body").animate(
        {
          scrollTop:
            $(`#${href[1]}`).offset().top - $(".main-nav").outerHeight(),
        },
        1000,
      );
    });

  // class toggles

  // $('.accordion__header').click(function() {
  //     // hierarchyToggle.toggleClass('hidden');
  //     $(this).parents().toggleClass('hidden');
  //     AOS.refresh();
  //     showcaseSlider.update();
  //     return false;
  // });

  $(".side-nav .nav-wrapper > .menu > .menu-item-has-children > a").click(
    function () {
      // hierarchyToggle.toggleClass('hidden');
      $(this).parents().toggleClass("hidden");

      // $('.sub-menu', this).toggleClass('hidden');
      console.log("clicked!");
      // $(this).parents().toggleClass('hidden');
      AOS.refresh();
      return false;
    },
  );

  $(".search-btn").click(function () {
    $(".search-modal").toggleClass("hidden");

    // $('.sub-menu', this).toggleClass('hidden');
    // $(this).parents().toggleClass('hidden');
    // AOS.refresh();
    // return false;
  });

  $(document).on("keyup", function (e) {
    if (e.key == "Escape") {
      if (!$(".search-modal").hasClass("hidden")) {
        $(".search-btn").click();
      }
    }
  });
});
